export default __webpack_public_path__ + "static/media/julian_step_1.2df0eb96.svg";